import React from 'react';
export const AccordionContext = React.createContext(null);
export const AccordionGroupContext = React.createContext(null);
